import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ComplaintsPage } from '@/features/ndis-standards/complaints'
import { requireActiveSubscription } from '@/lib/middleware'

// Phase 3c — the register keeps its selection and its trend panel in the URL, so
// a row a person is looking at survives a reload and can be linked to from an
// obligation on the hub.
const searchSchema = z.object({
  complaint: z.string().optional(),
  view: z.enum(['register', 'trend']).optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/complaints/')({
  validateSearch: searchSchema,
  beforeLoad: async () => requireActiveSubscription(),
  component: ComplaintsPage,
})
